
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Detail from './detail/index.vue'
import util from '@/utils/busi/util'
import { UserModule } from '@/store/modules/user'
import { getOperaLogList, getOperaLogInfo } from '@/api/systemset'
@Component({
  name: 'operate-log',
  components: {
    SimpleTable,
    Detail
  }
})
export default class OperateLog extends Vue {
  get userName () {
    return UserModule.name
  }

  private dialogVisible = !1

  private detailData: any = {}

  private form: any = {
    createTime: []
  }

  private closeDialog () {
    // do
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [{
    prop: 'rightName',
    label: '操作名称',
    custom: !0,
    default: ['right.rightName']
  },
  {
    prop: 'legalType',
    label: '是否合法',
    disabled: !0,
    custom: !0
  },
  {
    prop: 'clientIp',
    label: '客户端ip',
    disabled: !0
  },
  {
    prop: 'userName',
    label: '操作用户',
    custom: !0,
    default: ['user.userName']
  },
  {
    prop: 'lastingTime',
    label: '操作时长',
    default: ['minValue', 'maxValue']
  },
  {
    prop: 'createTime',
    label: '操作时间',
    format: 'date',
    default: ['startTime', 'endTime']
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    temp['right.rightName'] = temp.rightName
    temp['user.userName'] = temp.userName
    if (temp.createTime && temp.createTime.length > 0) {
      temp.startTime = temp.createTime[0]
      temp.endTime = temp.createTime[1]
    }
    delete temp.createTime
    delete temp.rightName
    delete temp.userName
    const form = util.trimForm({ ...temp })
    await getOperaLogList({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.count
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private legalType (val: any) {
    const dict: any = {
      1: '合法使用',
      2: '非法使用',
      3: '越权使用',
      4: '无权使用'
    }
    return dict[val]
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private async showDetail (row: any) {
    await getOperaLogInfo({
      uuid: row.uuid
    }).then((res: any) => {
      if (res.code === 10000) {
        this.detailData = res.object.info
        this.detailData.legalType = this.legalType(this.detailData.legalType)
      }
    })
    this.dialogVisible = !0
  }

  beforeMount () {
    this.onQuery()
  }
}
